//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import(/* webpackChunkName: "herb" */ './indexAppl');
const edit = () => import('./edit.vue');
const recommend=()=>import('./recommend.vue');

export default {
  routes: [
    {
      path: '/china/v2025/indexAppl',
      name: 'china_v2025_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/china/v2025/indexAdmin',
      name: 'china_v2025_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/china/v2025/edit',
      name: 'china_v2025_edit',
      component: edit,
      meta: {public: true}
    },
    {
      path: '/china/v2025/recommend',
      name: 'china_v2025_recommend',
      component: recommend,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/china2025/V2025/router.js